import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { dealerActionCreators, DealerActionKeys, FetchDealerOrders } from '..';
import { orderActionCreators } from '../../order';
import { showFailedRequestDialog } from '../../sagaUtils';
import { fetchOrders } from '../dealerApi';

function* fetchDealerOrdersSaga(action: FetchDealerOrders) {
  const response = yield* call(fetchOrders, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(orderActionCreators.setMinOrders(response.value.items));
    yield put(dealerActionCreators.fetchOrdersFulfilled(action.payload.accountNum, response.value));
  }
}

export function* watchFetchDealerOrders() {
  yield takeEvery(DealerActionKeys.FETCH_DEALER_ORDERS, fetchDealerOrdersSaga);
}
